export { default as RatingInput } from './rating-input';
export type { RatingInputProps } from './types';
